import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const MessageModal = ({ isOpen, onClose, jobId, jobTitle }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);

  const mockMessages = [
  {
    id: 1,
    sender: 'Jan de Vries',
    senderRole: 'contractor',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113acd116-1763292512957.png",
    avatarAlt: 'Professional headshot of Dutch man with short brown hair wearing blue work shirt',
    message: 'Goedemiddag, ik heb interesse in deze opdracht. Ik heb 8 jaar ervaring met HVAC installaties.',
    timestamp: '2026-01-14T14:30:00',
    read: true
  },
  {
    id: 2,
    sender: 'U',
    senderRole: 'client',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1de93534e-1763301290608.png",
    avatarAlt: 'Professional headshot of businesswoman with blonde hair in gray blazer',
    message: 'Bedankt voor uw interesse. Kunt u volgende week maandag beginnen?',
    timestamp: '2026-01-14T15:15:00',
    read: true
  },
  {
    id: 3,
    sender: 'Jan de Vries',
    senderRole: 'contractor',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_113acd116-1763292512957.png",
    avatarAlt: 'Professional headshot of Dutch man with short brown hair wearing blue work shirt',
    message: 'Ja, dat is geen probleem. Ik kan maandag om 08:00 uur beginnen.',
    timestamp: '2026-01-14T15:45:00',
    read: true
  }];


  useEffect(() => {
    if (isOpen) {
      setMessages(mockMessages);
    }
  }, [isOpen]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleTimeString('nl-NL', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleSendMessage = (e) => {
    e?.preventDefault();
    if (newMessage?.trim()) {
      const newMsg = {
        id: messages?.length + 1,
        sender: 'U',
        senderRole: 'client',
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1de93534e-1763301290608.png",
        avatarAlt: 'Professional headshot of businesswoman with blonde hair in gray blazer',
        message: newMessage,
        timestamp: new Date()?.toISOString(),
        read: true
      };
      setMessages([...messages, newMsg]);
      setNewMessage('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-1030 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative bg-white border-2 border-slate-200 rounded-lg w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden"
        style={{
          boxShadow: '0 20px 60px rgba(0,0,0,0.2), 0 10px 30px rgba(0,0,0,0.12)'
        }}>
        
        <div className="bg-card border-b border-border px-4 md:px-6 py-4 flex items-center justify-between">
          <div className="flex-1 min-w-0">
            <h2 className="font-heading font-semibold text-lg md:text-xl text-foreground truncate">
              Berichten
            </h2>
            <p className="caption text-muted-foreground truncate">{jobTitle}</p>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={24} />
          </Button>
        </div>

        <div className="flex-1 overflow-y-auto px-4 md:px-6 py-4 space-y-4">
          {messages?.map((msg) =>
          <div
            key={msg?.id}
            className={`flex gap-3 ${msg?.senderRole === 'client' ? 'flex-row-reverse' : ''}`}>

              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full overflow-hidden">
                <Image
                src={msg?.avatar}
                alt={msg?.avatarAlt}
                className="w-full h-full object-cover" />

              </div>
              <div className={`flex-1 ${msg?.senderRole === 'client' ? 'text-right' : ''}`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className="caption font-medium text-foreground">
                    {msg?.sender}
                  </span>
                  <span className="caption text-muted-foreground">
                    {formatTimestamp(msg?.timestamp)}
                  </span>
                </div>
                <div
                className={`inline-block px-4 py-2 rounded-lg text-sm ${
                msg?.senderRole === 'client' ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'}`
                }>

                  {msg?.message}
                </div>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        <form onSubmit={handleSendMessage} className="border-t border-border px-4 md:px-6 py-4">
          <div className="flex gap-3">
            <input
              type="text"
              placeholder="Typ een bericht..."
              value={newMessage}
              onChange={(e) => setNewMessage(e?.target?.value)}
              className="flex-1 px-4 py-2 bg-background border border-input rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth" />

            <Button
              type="submit"
              variant="default"
              size="icon"
              disabled={!newMessage?.trim()}>

              <Icon name="Send" size={20} />
            </Button>
          </div>
        </form>
      </div>
    </div>);

};

export default MessageModal;